<template>
  <div>
    <div class="l-top-devider">
      <div class="l-top-left">
        <h1 class="l-title-h1">
          {{ messages["bofi_calculate_monthly_amount_title"] }}
        </h1>
        <p>{{ messages["bofi_calculate_monthly_amount_description"] }}</p>
      </div>
      <div class="l-top-right">
        <bank class="c-bank--top" />
      </div>
    </div>

    <div class="c-step gray-container c-car-price-row hide-on-desktop">
      <div>
        {{ xcSession.car.make + " " + xcSession.car.model }}
      </div>
      <div>
        {{ messages["bofi_calculate_monthly_amount_car_info_price"] }}:
        {{ carPriceFormatted.split(",")[0] }}
      </div>
    </div>

    <div class="c-step">
      <div class="c-step__title">
        <div class="c-step__title--tooltip-container">
          <div class="l-label">
            {{ messages["bofi_calculate_monthly_amount_step_1_title"] }}
          </div>
          <eclipseButton @infoButtonClicked="loanInfoButtonClicked"
          />
        </div>
        <div class="l-description">
          {{
            messages["bofi_calculate_monthly_amount_step_1_description"].replace(
              "%s",
              carPriceFormatted
            )
          }}
        </div>
      </div>
      <div class="c-step__action">
        <slider
          v-model="loanAmountInput"
          :max="xcSession.car.price"
          :min="rangeSliderLoan.min"
          @infoButtonClicked="loanInfoButtonClicked"
        />
      </div>
    </div>
    <div class="c-step">
      <div class="c-step__title">
        <div class="l-label">
          {{ messages["bofi_calculate_monthly_amount_step_2_title"] }}
        </div>
      </div>
      <div class="c-step__action">
        <div class="c-radio-blocks">
          <div class="c-radio-blocks__group">
            <template v-for="value in xcSession.durations">
              <div class="c-radio-blocks__block" v-bind:key="value">
                <input
                  v-bind:key="value"
                  type="radio"
                  :value="value"
                  name="amount"
                  :id="value + '-toggle'"
                  v-model.number="durationInput"
                />
                <label v-bind:key="value + '-toggle'" :for="value + '-toggle'">{{ value }}</label>
              </div>
            </template>
          </div>
          <span v-bind:class="monthlyAmountClass">{{ messages["bofi_calculate_monthly_amount_step_2_description"] }}</span>
        </div>
      </div>
    </div>
    <div class="c-step">
      <div class="c-step__title">
        <div class="c-step__title--tooltip-container">
          <div class="l-label">
            {{ messages["bofi_calculate_monthly_amount_step_3_title"] }}
          </div>
          <eclipseButton @infoButtonClicked="termInfoButtonClicked"
          />
        </div>
        <div class="l-description">
          {{ messages["bofi_calculate_monthly_amount_step_3_description"] }}
        </div>
      </div>
      <div class="c-step__action">
        <slider
          v-model="finalTermAmountInput"
          :max="maxFinalTermAmount"
          :min="rangeSliderClosingTerm.min"
          @infoButtonClicked="termInfoButtonClicked"
        />
      </div>
    </div>

    <div class="c-total-amount c-total-amount__border-top">
      <div class="c-total-amount__label">
        {{ messages["deposit_label"] }}
      </div>
      <div class="c-total-amount__amount">
        {{ formattedDepositAmount.split(",")[0] }}
      </div>
    </div>

    <div class="c-total-amount">
      <div class="c-total-amount__label">
        {{ messages["bofi_calculate_monthly_amount_fixed_interest_label"] }}
      </div>
      <div class="c-total-amount__amount">
        {{ messages["bofi_calculate_monthly_amount_fixed_interest_value"] }}
      </div>
    </div>

    <div class="c-total-amount c-total-amount__border-bottom">
      <div class="c-total-amount__label">
        {{ messages["bofi_caluclate_monthly_amount_total_price"] }}
      </div>
      <div class="c-total-amount__amount">
        {{ formattedTotalLoanAmount.split(",")[0] }}
      </div>
    </div>

    <div class="c-total-month">
      <div class="c-total-month__label">
        <div>
          {{ messages["bofi_caluclate_monthly_amount_monthly_payment"] }}
        </div>
        <span>{{ messages["bofi_caluclate_monthly_amount_payment_in_euros"] }}</span>
      </div>
      <div class="c-total-month__amount">
        {{ prettyMonthlyAmount.split(",")[0] }}
        <sup>,{{ prettyMonthlyAmount.split(",")[1] }}</sup>
      </div>
    </div>

    <bank class="c-bank--bottom" />

    <a href="#" class="o-btn" @click="submit" :disabled="isSubmissionDisabled">
      {{ messages["bofi_caluclate_monthly_amount_submit"] }}
    </a>
  </div>
</template>
<script>
import * as Api from "../../api";
import * as BofiUtils from "../../utils";
import { Bank, EclipseButton } from "../../includes";
import { Utils } from "@bvm/core";
import $ from "jquery";
import Slider from "../slider/slider";
import _ from "lodash";

export default {
  name: "CalculateMonthlyAmount",
  components: {
    Bank,
    Slider,
    EclipseButton,
  },
  data() {
    return {
      messages: {
        bofi_calculate_monthly_amount_title: "Bereken je maandbedrag",
        bofi_calculate_monthly_amount_description:
          "In 3 stappen jouw persoonlijke aanbod en zie direct wat je per maand betaalt voor je autolening.",
        bofi_calculate_monthly_amount_step_1_title: "Hoeveel wil je lenen?",
        bofi_calculate_monthly_amount_step_1_description: "In 3 stappen jouw persoonlijke aanbod en zie direct wat je per maand betaalt voor je autolening",
        bofi_calculate_monthly_amount_step_2_title: "In hoeveel maanden wil je de lening aflossen?",
        bofi_calculate_monthly_amount_step_2_description: "maanden",
        bofi_calculate_monthly_amount_step_3_title:
          "Wil je met een slottermijn het maandbedrag verlagen?",
        bofi_calculate_monthly_amount_step_3_description: "",
        bofi_caluclate_monthly_amount_total_price: "Totaalbedrag",
        bofi_caluclate_monthly_amount_monthly_payment: "Je betaalt per maand",
        bofi_caluclate_monthly_amount_payment_in_euros: "Alle bedragen zijn in euro’s",
        bofi_caluclate_monthly_amount_submit: "Vrijblijvend aanvragen",
        bofi_calculate_monthly_amount_car_info_price: "Verkoopprijs",
        bofi_calculate_monthly_amount_fixed_interest_label: "Vaste rente",
        bofi_calculate_monthly_amount_fixed_interest_value: "4,99%",
        deposit_label: "Aanbetaling",
      },
      xcSession: {
        product: "",
        vatIncluded: "",
        vatDeductible: "",
        showVat: "",
        durations: "",
        maxFinalTermAmountPerMonth: [],
        car: {
          imageUrl: "",
          buildMonth: 1,
          buildYear: "",
          make: "",
          model: "",
          mileage: "",
          price: 2250,
          priceExclVatInclBpm: 0,
          licensePlate: "",
        },
        form: {
          durationInMonths: 0,
          depositAmount: 0,
          finalTermAmount: 0,
        },
        totalLoanAmount: 0,
        monthlyAmount: 0,
      },
      rangeSliderLoan: {
        min: 1000,
      },
      rangeSliderClosingTerm: {
        min: 0,
        max: this.maxFinalTermAmount,
      },
      loanAmountInput: 0,
      durationInput: 0,
      finalTermAmountInput: 0,
      serverError: false,
      modalLoanId: "init",
      modalTermId: "init",
      dataLoading: true,
      dataPosting: false,
    };
  },
  watch: {
    loanAmountInput: function() {
      this.calculateMonthlyAmount();
    },
    durationInput: function(val) {
      this.xcSession.form.durationInMonths = val;
      this.calculateMonthlyAmount();
    },
    finalTermAmountInput: function(val) {
      this.xcSession.form.finalTermAmount = val;
      this.calculateMonthlyAmount();
    },
  },
  computed: {
    isSubmissionDisabled: function() {
      return this.serverError || this.dataLoading || this.dataPosting;
    },
    prettyMonthlyAmount: function() {
      return BofiUtils.formatMoneyNoStrip(this.xcSession.monthlyAmount);
    },
    maxFinalTermAmount: function() {
      return this.xcSession.form.durationInMonths
        ? this.xcSession.maxFinalTermAmountPerMonth[this.xcSession.form.durationInMonths]
        : this.rangeSliderClosingTerm.min;
    },
    carPriceFormatted: function() {
      return BofiUtils.formatMoney(this.xcSession.car.price);
    },
    formattedTotalLoanAmount: function() {
      return BofiUtils.formatMoneyNoStrip(this.xcSession.totalLoanAmount);
    },
    formattedDepositAmount: function() {
      return BofiUtils.formatMoneyNoStrip(this.xcSession.form.depositAmount);
    },
    monthlyAmountClass: function() {
      return this.xcSession.durations.length >= 7 ? "hide-on-mobile" : "";
    },
  },
  beforeMount() {
    Api.Credit.getCalculationData()
      .then(data => {
        this.xcSession.car.buildMonth = data.buildMonth;
        this.xcSession.car.buildYear = data.buildYear;
        this.xcSession.car.imageUrl = data.imageUrl;
        this.xcSession.car.make = data.make;
        this.xcSession.car.mileage = data.mileage;
        this.xcSession.car.model = data.model;
        this.xcSession.car.price = data.price;
        this.xcSession.car.licensePlate = data.licensePlate;
        this.xcSession.car.priceExclVatInclBpm = data.priceExclVatInclBpm;
        this.xcSession.durations = data.durations;
        this.xcSession.maxFinalTermAmountPerMonth = data.maxFinalTermAmountPerMonth;
        this.xcSession.product = data.product;
        this.xcSession.vatDeductible = data.vatDeductible;
        this.xcSession.vatIncluded = data.vatIncluded;
        this.xcSession.showVat = !data.vatIncluded || (data.vatIncluded && data.vatDeductible);
        this.rangeSliderClosingTerm.max = this.xcSession.maxFinalTermAmountPerMonth[
          this.xcSession.form.durationInMonths
        ];
        let urlParameters = Utils.Url.getQueryParameters();
        this.durationInput = urlParameters.duration
          ? urlParameters.duration
          : Math.min.apply(null, data.durations);
        this.loanAmountInput = Number(urlParameters.loan || this.rangeSliderLoan.min);
        this.finalTermAmountInput = Number(urlParameters.term || this.rangeSliderClosingTerm.min);
        this.calculateMonthlyAmount();
        this.serverError = false;
        this.dataLoading = false;
      })
      .catch(() => {
        this.serverError = true;
      });

    // Get loan modal content
    Api.Credit.getBofiArticleInfo("BOFI_LOAN_INFO")
      .then(info => {
        this.modalLoanId = info.id;
      })
      .catch(error => {
        console.error(error);
      });

    // Get term modal content
    Api.Credit.getBofiArticleInfo("BOFI_TERM_INFO")
      .then(info => {
        this.modalTermId = info.id;
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    calculateMonthlyAmount: _.debounce(function() {
      if (this.xcSession.form.finalTermAmount > this.maxFinalTermAmount) {
        this.xcSession.form.finalTermAmount = this.maxFinalTermAmount;
      }
      this.xcSession.form.depositAmount = this.xcSession.car.price - this.loanAmountInput;

      Api.Credit.getMonthlyAmount(this.xcSession.form)
        .then(data => {
          this.xcSession.monthlyAmount = data.monthlyAmount;
          this.xcSession.totalLoanAmount = data.totalLoanCost;
          this.xcSession.maxFinalTermAmountPerMonth = data.maxFinalTermAmountPerMonth;
          this.xcSession.form.finalTermAmount = data.finalTermAmount;
          this.serverError = false;
        })
        .catch(() => {
          this.serverError = true;
        });
    }, 500),
    submit: function(e) {
      e.preventDefault();

      if (this.isSubmissionDisabled) {
        return;
      }

      this.dataPosting = true;

      if (this.xcSession.form.finalTermAmount > this.maxFinalTermAmount) {
        this.xcSession.form.finalTermAmount = this.maxFinalTermAmount;
      }
      this.xcSession.form.depositAmount = this.xcSession.car.price - this.loanAmountInput;

      Api.Credit.submitMonthlyAmount(this.xcSession.form)
        .then(data => {
          if (data.redirectUrl) {
            location.href = data.redirectUrl;
            this.serverError = false;
          } else {
            this.serverError = true;
            this.dataPosting = false;
          }
        })
        .catch(() => {
          this.serverError = true;
          this.dataPosting = false;
        });
    },
    loanInfoButtonClicked() {
      $(`[data-target="modal-${this.modalLoanId}"]`).click();
    },
    termInfoButtonClicked() {
      $(`[data-target="modal-${this.modalTermId}"]`).click();
    },
  },
};
</script>
